import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const RECOMMENDED_ACCOMMODATION_MODULE = 'RECOMMENDED_ACCOMMODATION';

export const DEFAULT_RECOMMENDED_ACCOMMODATION_COLUMNS: Column[] = [{
    label: 'accommodation-name',
    field_name: 'ACCOMMODATION_NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'stars',
    field_name: 'STARS',
    checked: true,
    order_by: 'stars',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'address',
    field_name: 'ADDRESS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'city',
    field_name: 'CITY',
    checked: true,
    order_by: 'city_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country-code',
    field_name: 'COUNTRY_CODE',
    checked: true,
    order_by: 'country_code',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'custom-picture(s)',
    field_name: 'CUSTOM_PICTURES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'referential-picture(s)',
    field_name: 'REFERENTIAL_PICTURES',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'recommended',
    field_name: 'RECOMMENDED',
    checked: true,
    order_by: 'favorite',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'blacklisted',
    field_name: 'BLACKLISTED',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'tags',
    field_name: 'TAGS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'allowed-cms',
    field_name: 'ALLOWED_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const setRecommendedAccommodationPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: RECOMMENDED_ACCOMMODATION_MODULE, default_columns: DEFAULT_RECOMMENDED_ACCOMMODATION_COLUMNS, default_order_by: 'name', default_order: 'asc' });
